module.exports = __webpack_public_path__ + "img/superiority1.aa82daf2.png";